import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import authService from '../../services/authservice';

interface ILoginEmailProps {
  username: string;
  password: string;
}

export const loginWithEmail = createAsyncThunk(
  'auth/loginWithEmail',
  async ({username, password}: ILoginEmailProps) => {
    const response = await authService.loginWithEmail(username, password);
    return response;
  },
);

export const logout = createAsyncThunk('auth/logout', () => {
  authService.logout();
});

export type AuthStateType = {
  loggedIn: boolean;
  loggingIn: boolean;
  token: string | null;
  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
  error: any | null;
};

const initialState: AuthStateType = {
  loggedIn: false,
  loggingIn: false,
  token: null,
  error: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(loginWithEmail.fulfilled, (state, action) => {
      state.loggingIn = false;
      state.loggedIn = true;
      state.token = action.payload;
    });
    builder.addCase(loginWithEmail.rejected, (state, action) => {
      state.loggingIn = false;
      state.loggedIn = false;
      state.error = action.payload;
    });
    builder.addCase(logout.fulfilled, (state) => {
      state.loggingIn = false;
      state.loggedIn = false;
      state.error = null;
    });
  },
});

export default authSlice.reducer;
